import { Route, Switch } from "wouter";

import { Home } from "./pages/Home.js";
import { Pay } from "./pages/Pay.js";
import { Start } from "./pages/Start.js";

function Header() {
  return (
    <header className="flex items-center justify-between px-6 py-3 border-b border-border/80">
      <a href="/" className="block leading-none no-underline hover:opacity-90 transition-opacity">
        <img src="/logo-2.png" alt="TeamTable" className="h-8 w-auto object-contain" />
      </a>
    </header>
  );
}

export function App() {
  return (
    <>
      <Header />
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/start" component={Start} />
        <Route path="/pay/session/:sessionId" component={Pay} />
        <Route path="/pay/:deviceId" component={Pay} />
      </Switch>
    </>
  );
}
